import React, { useEffect, useState } from 'react';
import Swiper from 'swiper';
import '../../public/dist/swiper/swiper.css';

import Link from 'next/link';
import { ajaxor2 } from '../common/basic';

export default props=>{
  const [vBanners, setBanners] = useState([]);
  useEffect(() => {
    ajaxor2({
      url: '/promotions/textBanners',
      callback: callback,
    });
    function callback(rd){
      // console.log("rd: ", rd);
      setBanners(rd);
      // setText(rd.body);
      initSwiper();

    }


    return ()=>{;}
  }, []);

  function initSwiper(){
    var mySwiper = new Swiper('#idswiper_up.swiper-container', {
      autoplay: {
        delay: 5000,
        // disableOnInteraction: false,
      },


      // Optional parameters
      direction: 'horizontal',
      loop: true,

      // If we need pagination
      pagination: {
        el: '#idswiper_up .swiper-pagination',
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return '< <span style="color:white;" class="' + currentClass + '"></span>' +
            ' / ' +
            '<span style="color:white;" class="' + totalClass + '"></span> >';
        }
      }
    });

  }

  const jsx = (<div className="pan1" >
    <style jsx>{`
.pan1{
  text-align: center;
}

.rightp{
  font-size: 12px;
  line-height: 1;
  float: right;
  padding: 28px;

}

.display-inline{
  display: inline;
  color: white;
}
.current{}
.total{}

.pan1 {
  width: 100%;
  min-width:1290px;
  height: 70px;
  background-color: rgba(33, 37, 41, 0.9);
  margin: 0 auto;
}

.text1 {
  font-family: NotoSansCJKkr;
  font-size: 14px;
  line-height: 1;
  color: #ffffff;

  text-align: center;
  padding: 28px 0 0 0;
}

.text1 p{
}

.text1 p span{
}

@media all and (max-width:606px) {
  .pan1 {
    width: 100%;
    min-width:100px;
  }
  .rightp{display: none;}
}

.left-right{
  height:10px;
}

#idswiper_up .swiper-pagination{
  color: white;
  font-size: 12px;
  text-align: left;
  left: calc(50% + 590px);
  vertical-align: middle;
  bottom: auto;
  top: 27px;

}

`}</style>

    <div id="idswiper_up" className="swiper-container">
      <div className="swiper-wrapper">

        {vBanners.map((v,i)=>(
          <div key={i} className="swiper-slide">
            {v.url?
              <a href={v.url} target="_blank">
                <div className="dib text1" >
                  {v.body}
                </div>
              </a>
            :
              <div className="dib text1" >
                {v.body}
              </div>
            }
          </div>
        ))}
{/* 
        <div className="swiper-slide">
          <a href="https://www.google.co.kr" target="_blank">
            <div className="dib text1" >
              캠스콘이 지원하는 학교 패션 피플222
            </div>
          </a>
        </div> */}

      </div>
      <div className="swiper-pagination"></div>
    </div>

  </div>);
  return(jsx);
}
